import env from '../config/env'

export default interface User {
  avatar?: {
    id: number,
    url: string,
    small: string,
    large: string,
    medium: string,
    tiny: string,
  }
  id: number
  name: string
  email: string
  city: string
  phone: string
  cpf: string
  birth_year: string
  profession: string
  gender: Gender
  realties_count: number
  roles: {
    id: number
    name: string
  }[]
  chat_room?: {
    uuid: string
  }
  created_at: string
  verified: boolean
}

type Gender = '' | 'MALE' | 'FEMALE' | 'NOT_INFORMED' | 'OTHER'

export const GENDER: { [key in Gender]: string } = {
  '': '-',
  OTHER: 'Outro',
  MALE: 'Homem',
  FEMALE: 'Mulher',
  NOT_INFORMED: 'Não informado',
}
export function isInRole(user: User, role: string) {
  return user.roles.filter((item: { name: string }) => {
    return item.name === role
  }).length > 0
}

export const defaultAdmin: User = {
  "id": env.defaultAdminId,
  "name": env.defaultAdminName,
  "email": "padilha.ziraldo@example.com",
  "roles": [], "phone": "4065-9174",
  "city": "",
  "cpf": "",
  "birth_year": "0",
  "profession": "",
  "gender": "",
  "realties_count": 0,
  "verified": false,
  "created_at": "2020-04-03T15:39:27.000000Z"
} 
